import gql from 'graphql-tag';

export const GET_IMAGE = gql`
  query getImage(
    $personId: ID!, 
    $projectId: ID!, 
    $referenceId: ID!
  ) {
    Image(
      personId: $personId, 
      projectId: $projectId, 
      referenceId: $referenceId
    ){
      __typename
      id,
      title,
      subtitle,
      version,
      creationDate {formatted},
      creationDateIsApproximate,
      lastModifiedDate {formatted},
      type,
      proprietaryId,
      proprietaryIdNamespace,
      status,
      url,
      project {
        id,
        title,
        status,
        type,
        owners {
          id,
          fullName,
          __typename
        }
      }
      comments {
        id,
        text,
        creationDate {
          formatted
        }
        lastModifiedDate { formatted },
        author {
          id,
          accountId,
          fullName,
          imageDepictions {
            id,
            title,
            type,
            thumbnail { 
              id, 
              file { 
                uri 
                }
              }
            }
          __typename
        }
      }
      genres {
        id,
        name
      }
      contributions {
        id,
        contributor {
          id,
          fullName,
          __typename
        }
        role,
        isCredited,
        creditText,
        featured
      }
      rightShares {
        id,
        percent,
        territoryCode,
        owners {
          id,
          fullName,
          __typename
        }
        controllers {
          id,
          fullName,
          __typename
        }
        administrators {
          id,
          fullName,
          __typename
        }
        for {
          id,
          role
        }
      }
      file {
        id,
        proprietaryId,
        fileName,
        fileType,
        uri,
        size,
        bitDepth,
        bitRate,
        samplingRate,
        codecType
      }
      versions {
        id,
        title,
        file {
          id,
          proprietaryId,
          fileName,
          fileType,
          uri
        }
      }
      isVersionOf {
        id,
        title,
        file {
          id,
          proprietaryId,
          fileName,
          fileType,
          uri
        }
      }
      mood {
        id,
        name
      }
      equipment {
        id,
        name,
        type
      }
      referrer {
        __typename,
        ...on Project {
          id,
          title,
          status,
          type,
          owners {
            id,
            fullName,
            __typename
          }
        }
      }
      resourceOf {
        __typename,
        ...on Project {
          id,
          title,
          status,
          type,
          owners {
            id,
            fullName,
            __typename
          }
        }
      }
      height,
      width,
      thumbnail {
        id,
        file {
          id,
          uri
        }
      }
    }
  }
`;

export const CREATE_IMAGE = gql`
  mutation createImage (
    $id: ID,
    $title: String,
    $subtitle: String,
    $version: String,
    $creationDate: _Neo4jDateTimeInput,
    $creationDateIsApproximate: Boolean,
    $lastModifiedDate: _Neo4jDateTimeInput,
    $type: String,
    $proprietaryId: String,
    $proprietaryIdNamespace: String,
    $status: String,
    $url: String,
    $height: Int,
    $width: Int
  ){
    CreateImage(
      id: $id,
      title: $title,
      subtitle: $subtitle,
      version: $version,
      creationDate: $creationDate,
      creationDateIsApproximate: $creationDateIsApproximate,
      lastModifiedDate: $lastModifiedDate,
      type: $type,
      proprietaryId: $proprietaryId,
      proprietaryIdNamespace: $proprietaryIdNamespace,
      status: $status,
      url: $url,
      height: $height,
      width: $width
    ) {
        id,
        title,
        subtitle,
        version,
        creationDate {formatted},
        creationDateIsApproximate,
        lastModifiedDate {formatted},
        type,
        proprietaryId,
        proprietaryIdNamespace,
        status,
        url,
        height,
        width
    }
  }
`;

export const CREATE_IMAGE_WITH_REFERRER = gql`
  mutation createImageWithReferrer (
    $personId: ID!,
    $url: String!,
    $projectId: ID!,
  ){
    CreateImageWithReferrer(
      partyId: $personId,
      url: $url,
      projectId: $projectId,
    ) {
        id,
        title,
        subtitle,
        version,
        creationDate {formatted},
        creationDateIsApproximate,
        lastModifiedDate {formatted},
        type,
        proprietaryId,
        proprietaryIdNamespace,
        status,
        url,
        height,
        width
    }
  }
`;

export const UPDATE_IMAGE = gql`
  mutation updateImage (
    $personId: ID!,
    $input: ImageInput
  ) {
    UpdateImage(
      personId: $personId,
      input: $input
    ) {
        id,
        title,
        subtitle,
        version,
        creationDate {formatted},
        creationDateIsApproximate,
        lastModifiedDate {formatted},
        type,
        proprietaryId,
        proprietaryIdNamespace,
        status,
        url,
        height,
        width
        __typename
    }
  }
`;

export const DELETE_IMAGE = gql`
  mutation deleteImage (
    $personId: ID!,
    $referenceId: ID!
  ) {
    DeleteImage(
      personId: $personId,
      referenceId: $referenceId
  ) {
    id
  }
}
`;

export const ADD_IMAGE_REFERRER = gql`
  mutation addImageReferrer (
    $from: _ProjectInput!
    $to: _ImageInput!
  ) {
  AddImageReferrer(
    from: $from
    to: $to
  ) {
    from { id }
    to { id }
    }
  }
`;

// AddImageProject(
//   from: _ProjectInput!
//   to: _ImageInput!
// ): _AddImageProjectPayload
// RemoveImageProject(
//   from: _ProjectInput!
//   to: _ImageInput!
// ): _RemoveImageProjectPayload
// AddImageComments(
//   from: _CommentInput!
//   to: _ImageInput!
// ): _AddImageCommentsPayload
// RemoveImageComments(
//   from: _CommentInput!
//   to: _ImageInput!
// ): _RemoveImageCommentsPayload
// AddImageGenres(from: _GenreInput!, to: _ImageInput!): _AddImageGenresPayload
// RemoveImageGenres(
//   from: _GenreInput!
//   to: _ImageInput!
// ): _RemoveImageGenresPayload
// AddImageContributions(
//   from: _ContributionInput!
//   to: _ImageInput!
// ): _AddImageContributionsPayload
// RemoveImageContributions(
//   from: _ContributionInput!
//   to: _ImageInput!
// ): _RemoveImageContributionsPayload
// AddImageRightShares(
//   from: _ShareInput!
//   to: _ImageInput!
// ): _AddImageRightSharesPayload
// RemoveImageRightShares(
//   from: _ShareInput!
//   to: _ImageInput!
// ): _RemoveImageRightSharesPayload
// AddImageFile(from: _ImageInput!, to: _FileInput!): _AddImageFilePayload
// RemoveImageFile(from: _ImageInput!, to: _FileInput!): _RemoveImageFilePayload
// AddImageMood(from: _MoodInput!, to: _ImageInput!): _AddImageMoodPayload
// RemoveImageMood(from: _MoodInput!, to: _ImageInput!): _RemoveImageMoodPayload
// AddImageEquipment(
//   from: _ImageInput!
//   to: _EquipmentInput!
// ): _AddImageEquipmentPayload
// RemoveImageEquipment(
//   from: _ImageInput!
//   to: _EquipmentInput!
// ): _RemoveImageEquipmentPayload
// AddImageDisplayedInRelease(
//   from: _ReleaseDetailInput!
//   to: _ImageInput!
// ): _AddImageDisplayedInReleasePayload
// RemoveImageDisplayedInRelease(
//   from: _ReleaseDetailInput!
//   to: _ImageInput!
// ): _RemoveImageDisplayedInReleasePayload
// AddImageThumbnail(
//   from: _ImageInput!
//   to: _ImageInput!
// ): _AddImageThumbnailPayload
// RemoveImageThumbnail(
//   from: _ImageInput!
//   to: _ImageInput!
// ): _RemoveImageThumbnailPayload
